/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, NgZone } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocationService } from '@shared/services/location.service';
import { ModalController, Platform, ToastController } from '@ionic/angular';
import { PushNotifications } from '@capacitor/push-notifications';
import { Geolocation } from '@capacitor/geolocation';
import { AdMob } from '@capacitor-community/admob';
import { Capacitor } from '@capacitor/core';
import { Adjust } from '@awesome-cordova-plugins/adjust';
import { Device } from '@capacitor/device';
import { StatusBar } from '@capacitor/status-bar';
import { register } from 'swiper/element/bundle';
import { ProfilePage } from './pages/profile/profile.page';
import { UtilService } from '@shared/utils/util';
import { Preferences } from '@capacitor/preferences';
import { FcmService } from '@shared/services/fcm.service';
import { MatchService } from './services/match.service';
import { ChatPage } from './pages/chat/chat.page';
import { InAppBrowser } from '@capgo/inappbrowser';
import { UserService } from '@shared/services/user.service';
import { PurchaseService } from './services/purchase.service';
import { Router } from '@angular/router';
import { App } from '@capacitor/app';
import { Camera } from '@capacitor/camera';
import { NotificationsTypesEnum } from '@shared/enums/NotificationsTypesEnum';
import { SurveyPage } from './pages/survey/survey.page';
import { EventService } from '@shared/services/event.service';
import { StoreV2Page } from './pages/store-v2/store-v2.page';
import { LanguageEnum } from '@shared/enums/LanguageEnum';
import { environment } from '../environments/environment';
import { FirebaseCrashlyticsService } from '@shared/services/firebase-crashlytics.service';
import { FirebaseAnalyticsService } from '@shared/services/firebase-analytics.service';
import { FacebookEvents } from 'capacitor-facebook-events';
import { ProfileDisplayPage } from 'src/app/pages/profile-display/profile-display.page';
import { ThemeSettingsPage } from 'src/app/pages/theme-settings/theme-settings.page';
import { ValidationService } from './services/validation.service';
import { Subscription } from 'rxjs';
import { WebBlocker } from '@shared/decorators/web-blocker.decorator';
import { ConnectionStateService } from '@shared/services/connection-state.service';
import { AppStateService } from '@shared/services/app-state.service';
import { AnalyticsService } from './services/analytics.service';
import { PosthogService } from '@shared/services/posthog.service';

register();


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  providers: [UtilService, ValidationService]
})
export class AppComponent {
  public theme = 'light';
  private scrollSubscription!: Subscription;
  // rootPage: any = TabsPage;
  public userData: any;
  isIos: boolean = false;
  private userDeniedLocation: boolean = false;
  private isNative: boolean = true;
  public static isUnsubscribe: boolean = false;
  public static idfa: string | null = null;
  public static aaid: string | null = null;
  public surveyEnabled = false;
  //private firebasePlugin: any;

  public firebasePlugin: any;

  constructor(
    public userService: UserService,
    private platform: Platform,
    private locationService: LocationService,
    private translate: TranslateService,
    private modalCtrl: ModalController,
    private util: UtilService,
    private fcm: FcmService,
    private router: Router,
    public firebaseCrashlytics: FirebaseCrashlyticsService,
    private firebaseAnalytics: FirebaseAnalyticsService,
    private matchService: MatchService,
    private purchaseServiceProvider: PurchaseService,
    private zone: NgZone,
    private eventService: EventService,
    private validationService: ValidationService,
    private connectionStateService: ConnectionStateService,
    public appStateService: AppStateService,
    private analyticsService: AnalyticsService,
    public toastCtrl: ToastController,
    private posthog: PosthogService
  ) {
    this.initializeApp();
    this.loadTheme();

    Preferences.get({ key: 'USER_DATA' }).then((val: any) => {
      this.userData = val.value ? JSON.parse(val.value) : null;
    });

    this.util.initTranslate();
    this.initPurchase();
    this.initApp();

    platform.ready().then(async () => {

      this.isIos = platform.is('ios');
      this.isNative = this.util.isNative();

      // Initialize PostHog for user behavior tracking and session replay
      try {
        await this.posthog.initialize({
          apiKey: environment.posthog.apiKey,
          apiHost: environment.posthog.apiHost,
          appName: environment.posthog.appName,
          uiHost: environment.posthog.uiHost,
        });
        console.log('✅ PostHog initialized for Fyra');
      } catch (error) {
        console.error('❌ PostHog initialization failed:', error);
      }

      // Configurar Adjust através do AppStateService
      this.appStateService.setAdjustLogLevel();

      // Inicializar Adjust SDK no boot (não-lazy).
      // Antes a init era feita lazy dentro de analytics.service.ts:initializeAdjust(),
      // só na primeira chamada de sendEventToAnalytics — eventos anteriores perdidos
      // e o SDK não rastreava sessão/attribution/deep links desde o boot.
      if (Capacitor.isNativePlatform() && this.appStateService.adjustConfig) {
        try {
          Adjust.initSdk(this.appStateService.adjustConfig);
          console.log('✅ Adjust SDK inicializado no boot');
        } catch (e) {
          console.error('❌ Erro inicializando Adjust no boot:', e);
          this.firebaseCrashlytics.log('Adjust init failed on boot: ' + JSON.stringify(e));
        }
      }

      AppComponent.isUnsubscribe = false;

      this.matchService;

      this.authenticationInstagram();
      this.purchaseServiceProvider.validateSubscriptionsStartup();
      console.log('Will read IDFA plugin...');
      await this.configurePushNotification();
      this.handleAppStateChange();
      this.setAnalyticsUserIds();
      this.facebooksetAdvertiserTrackingEnabled();
      this.configureSubscription();
    });
  }

  configureSubscription() {
    this.scrollSubscription = this.validationService.blockScroll$.subscribe(
      (shouldBlock) => {
        // 4. Chame a função que manipula o 'document.body'
        this.toggleBodyScroll(shouldBlock);
      }
    );
  }

  private toggleBodyScroll(block: boolean): void {
    if (block) {
      console.log('BLOQUEANDO SCROLL (lógica centralizada no AppComponent)');
      document.body.style.overflow = 'hidden';
      document.body.style.touchAction = 'none';
    } else {
      console.log('LIBERANDO SCROLL (lógica centralizada no AppComponent)');
      document.body.style.overflow = '';
      document.body.style.touchAction = '';
    }
  }

  facebooksetAdvertiserTrackingEnabled() {
    if (!this.isNative) {
      return;
    }

    // Enable Meta auto-logging / advertiser tracking only in production.
    // Development and test builds still use the production Facebook App ID,
    // so leaving auto-log on would send StoreKit IAP events into production analytics.
    const enabled = environment.production;
    try {
      FacebookEvents.setAdvertiserTrackingEnabled({ enabled }).then(_result => {
        console.log(`setAdvertiserTrackingEnabled: ${enabled}`);
      }).catch(error => {
        this.firebaseCrashlytics.log('Error on setAdvertiserTrackingEnabled: ' + JSON.stringify(error))
      })
    } catch (error) {
      console.log('Error on setAdvertiserTrackingEnabled: ' + JSON.stringify(error));
      this.firebaseCrashlytics.log('Error on setAdvertiserTrackingEnabled: ' + JSON.stringify(error))
    }
  }

  applyTheme(theme: string) {
    let newTheme;
    if (this.theme === 'system') {
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      newTheme = prefersDark ? 'dark' : 'light'
    } else {
      this.theme = theme;
      newTheme = theme;
    }
    document.documentElement.setAttribute('color-theme', newTheme);
  }


  async loadTheme() {
    const savedTheme = await Preferences.get({ key: 'theme' });

    if (savedTheme.value) {
      this.theme = savedTheme.value;
    } else {
      // Detecta a preferência do sistema
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      this.theme = prefersDark ? 'dark' : 'light';
    }

    this.applyTheme(this.theme);
  }

  async openThemeSettings() {
    const modal = this.modalCtrl.create({ component: ThemeSettingsPage, componentProps: { theSoul: this.userData } });
    (await modal).onDidDismiss().then((val: any) => {
      console.log('data returned from PreferencesPage: ' + (val != null && val.data != null) ? JSON.stringify(val.data) : "null");
      if (val.data != undefined && val.data != null && val.data != 'cancelled') {
        this.userData = val.data;
        Preferences.set({ key: 'USER_DATA', value: JSON.stringify(val.data) }).then((_val) => {
          console.log('userdata saved to DB');
        })
      }
    });

    (await modal).present();
  }


  async configurePushNotification() {
    console.log('Configuring push notifications...');
    if (!Capacitor.isNativePlatform()) {
      console.log('Not native platform, skipping push notification configuration');
      return;
    }

    // Permission request is now handled in initApp() via requestPushNotificationPermission()
    // This method only handles registration if permission is already granted

    // Only register if permission is already granted
    // Don't request permission here - that's done in requestPushNotificationPermission()
    try {
      const permStatus = await PushNotifications.checkPermissions();
      console.log('configurePushNotification: Permission status:', permStatus.receive);
      
      if (permStatus.receive === 'granted') {
        console.log('Permission already granted, registering push notifications...');
        await PushNotifications.register();
        console.log('Push notifications registered successfully');
      } else {
        console.log('Permission not granted yet, will be requested in initApp()');
      }
    } catch (error) {
      console.error('Error in configurePushNotification:', error);
    }
  }

  authenticationInstagram() {
    try {
      if (window.location.href.indexOf(`https://app.fyradating.com/?code=`) === 0) {
        const currentUrl = window.location.href;
        let authCodeIg = currentUrl.substring(`https://app.fyradating.com/?code=`.length);
        authCodeIg = authCodeIg.substring(0, authCodeIg.length - 2);
        const newUrl = new URL(location.href);
        newUrl.searchParams.delete('code');
        window.history.replaceState({}, document.title, newUrl.href);
        this.modalCtrl.create({ component: ProfilePage, componentProps: { code: authCodeIg } }).then((modal) => {
          modal.present();
        })
        // this.navChild.push(ProfilePage, { code: authCodeIg });
      }

    } catch (error) {
      console.log('Error on check if it is a return from authentication on instagram: ' + error);
    }
  }

  handleAppStateChange() {
    App.addListener('appStateChange', (state) => {
      if (!state.isActive) {
        console.log('[APP.COMPONENT] Main App paused');
        AppComponent.isUnsubscribe = true;
        // Marca que o app foi para background
        localStorage.setItem('appReturningFromBackground', 'true');
        if (this.isIos) {
          this.locationService.unSubscribeLocationRefresher();
        } else {
          this.locationService.unSubscribeLocationRefresher();
        }
      }
    });

    // Subscribing to the resume event
    App.addListener('appStateChange', async (state) => {
      if (state.isActive) {
        this.loadTheme();
        console.log('[APP.COMPONENT] Main App resumed');
        AppComponent.isUnsubscribe = false;

        // Aguarda um pouco para dar tempo da conexão se restabelecer
        await new Promise(res => setTimeout(res, 1000));

        // Usa o serviço de estado de conexão para verificar estabilidade
        const isConnectionStable = await this.connectionStateService.waitForStableConnection(3000);

        if (!isConnectionStable) {
          console.log('[APP.COMPONENT] Connection not stable after resume');
          // Só exibe o toast se realmente não há conexão
          this.util.showTopToastUnableToConnect(this.toastCtrl);
          return;
        }

        console.log('[APP.COMPONENT] Connection stable, resuming normal operations');

        if (this.isIos) {
          this.locationService.subscribeLocationRefresher();
        } else {
          if (localStorage.getItem('isLocationEnabled')) {
            this.locationService.subscribeLocationRefresher();
          }
        }

        this.purchaseServiceProvider.validateSubscriptionsStartup();
        if (Capacitor.isNativePlatform()) {
          this.setAnalyticsUserIds();
        }
      }
    });
  }


  initPurchase() {
    this.platform.ready().then(async () => {
      this.purchaseServiceProvider.configurePurchasing();
    })
  }

  replaceWithParameter(url: string, validPrefixes: Array<any>) {
    for (const prefix of validPrefixes) {
      const startIndex = url.indexOf(prefix);
      if (startIndex !== -1) {
        const parameter = url.substring(startIndex + prefix.length);
        return parameter;
      }
    }
    return url; // Retorna a URL original se nenhum prefixo for encontrado
  }

  initializeApp() {
    this.userService.captureAcquisitionAttribution(window.location.href);
    // Web: attribution from window.location. Native: Capacitor has no query
    // on window.location — persist referral/UTMs from launch + appUrlOpen so
    // Apple createConfirmed (attachReferralUserId) can read pending attribution.
    this.platform.ready().then(() => {
      try {
        App.getLaunchUrl()
          .then((ret) => {
            if (ret?.url) {
              this.userService.captureAcquisitionAttribution(ret.url);
            }
          })
          .catch(() => {
            // No cold-start URL (normal when opened from icon).
          });

        App.addListener('appUrlOpen', (event: any) => {
          this.zone.run(() => {
            if (event?.url) {
              this.userService.captureAcquisitionAttribution(event.url);
            }
            const prefixDeepLink = 'fyra://';
            const url = event.url.toLowerCase();
            const _validPrefixes = ['promotions', 'chat'];
            let slug: any;

            if (url.startsWith(prefixDeepLink)) {
              slug = url.replace(prefixDeepLink, '');
              if (url === 'fyra://fyra/survey' || url === 'fyra://survey') {
                this.openSurvey();
                return;
              } else if (url === 'fyra://fyra/promotions/club' || url === 'fyra://promotions/club') {
                Preferences.set({ key: 'CLUB_OPENED_FROM_NOTIFICATION_THIS_SESSION', value: 'true' }).then(() => {
                  this.openMembership();
                });
                return;
              }
            } else {
              const url = new URL(event.url);

              if (url.pathname.startsWith('/profile/')) {
                // const hash = url.pathname.split('/profile/')[1];
                // this.router.navigateByUrl(`/profile/${hash}`);
                // this.openProfile(hash);
              } else if (url.pathname.startsWith('/chat/')) {
                const hash = url.pathname.split('/chat/')[1];
                console.log(hash)
                this.verifyIsUserValid(hash)
              } else if (url.pathname === '/survey') {
                this.openSurvey();
              } else if (url.pathname === '/promotions/club') {
                Preferences.set({ key: 'CLUB_OPENED_FROM_NOTIFICATION_THIS_SESSION', value: 'true' }).then(() => {
                  this.openMembership();
                });
              }
            }


            this.router.navigateByUrl(slug);
          });
        });
      } catch (error) {
        console.error("Error in addListener appUrlOpen: " + error);
      }
    });
  }

  openProfile(hash: any) {
    this.userService.viewProfilePublic(hash).subscribe({
      next: async (data) => {
        if (data != '{not ok}') {
          const modal = await this.modalCtrl.create({
            component: ProfileDisplayPage,
            componentProps: { theSoul: JSON.parse(data) }
          });
          modal.present();
        }
      },
      error: async (error) => {
        console.log('Upsert error: ' + JSON.stringify(error.toString()));
      }
    });

  }

  removeVegglyPrefix(url: string) {
    const transformUrl = url.toLowerCase()
    const prefix = 'fyra://';
    if (transformUrl.startsWith(prefix)) {
      return transformUrl.replace(prefix, '');
    }
    return transformUrl;
  }

  initApp() {
    this.translate.setDefaultLang(LanguageEnum.EN);

    // Adiciona classe ao body baseado na plataforma
    if (Capacitor.isNativePlatform()) {
      document.body.classList.add('native');
      console.log('Native platform detected - added .native class to body');
    } else {
      console.log('Web platform detected - no width restrictions will be applied');
    }

    // Reset location toast flag when app is truly started (new session)
    // This allows showing the toast once per app session, even after navigating between pages
    localStorage.removeItem('LOCATION_TOAST_DISMISSED_THIS_SESSION');
    console.log('App initialized: Reset LOCATION_TOAST_DISMISSED_THIS_SESSION flag');
    // Reset club-opened-from-notification flag so each app session starts fresh (avoids double-open when notification + home both could open club)
    Preferences.remove({ key: 'CLUB_OPENED_FROM_NOTIFICATION_THIS_SESSION' });

    this.platform.ready().then(async () => {
      if (Capacitor.isNativePlatform()) {
        // Wait a bit for the app to be fully ready
        await new Promise(resolve => setTimeout(resolve, 2000));
        
        // Request location permissions FIRST
        console.log('Requesting location permissions FIRST...');
        await this.checkPermissionGeolcoation();
        
        // Immediately after location permission is resolved (accepted or denied),
        // request push notification permission
        console.log('Location permission resolved, requesting push notification permission...');
        await new Promise(resolve => setTimeout(resolve, 500)); // Small delay to ensure location dialog is closed
        await this.requestPushNotificationPermission();

        // App Tracking Transparency (iOS 14+). O app linka o framework ATT (via AdMob),
        // então a Apple exige que o prompt seja EXIBIDO. Antes ficava só na home (após
        // login+onboarding) e o revisor não o alcançava (rejeição). Agora dispara no
        // startup, independente de login, para o prompt sempre aparecer.
        await new Promise(resolve => setTimeout(resolve, 500));
        await this.requestAppTrackingTransparency();
      }

      await this.addListeners()
      await this.getGPSRead();

    })
  }


  /**
   * Solicita a permissão de App Tracking Transparency (iOS 14+) uma vez, quando ainda
   * não determinada. É via AdMob (mesmo mecanismo já usado na home). Chamado no startup
   * para garantir que o prompt apareça na revisão da App Store (rejeição: "unable to
   * locate the App Tracking Transparency permission request").
   */
  async requestAppTrackingTransparency() {
    if (Capacitor.getPlatform() !== 'ios') {
      return;
    }
    try {
      const info = await AdMob.trackingAuthorizationStatus();
      if (info.status === 'notDetermined') {
        // Pequeno delay para o app estar em foreground/active (requisito do prompt ATT).
        await new Promise(resolve => setTimeout(resolve, 300));
        await AdMob.requestTrackingAuthorization();
      }
    } catch (error) {
      console.log('ATT request error (ignorado): ' + JSON.stringify(error));
    }
  }

  async checkPermissionGeolcoation() {
    if (!Capacitor.isNativePlatform()) {
      return
    }
    try {
      let permissions = await Geolocation.checkPermissions();
      
      // Check if permission is already denied (user previously denied)
      const isAlreadyDenied = permissions.coarseLocation === 'denied' || permissions.location === 'denied';
      
      if (permissions.coarseLocation != 'granted' || permissions.location != 'granted') {
        // Only request if not already denied (to avoid showing dialog again)
        if (!isAlreadyDenied) {
          permissions = await Geolocation.requestPermissions({ permissions: ['coarseLocation', 'location'] });

          if (permissions.coarseLocation != 'granted' || permissions.location != 'granted') {
            // Count location permission denials when user denies the request
            await this.incrementLocationPermissionDenialCount();
            console.log('Location permission denied, but continuing to request push notification permission');
            // Don't throw - let the flow continue to request push notification permission
          } else {
            // Permission granted, reset denial count
            await Preferences.remove({ key: 'LOCATION_PERMISSION_DENIAL_COUNT' });
          }
        } else {
          // Permission already denied, ensure it's counted (only once)
          await this.ensureDeniedPermissionCounted();
        }
      } else {
        // Permission already granted, reset denial count
        await Preferences.remove({ key: 'LOCATION_PERMISSION_DENIAL_COUNT' });
      }
    } catch (error) {
      console.error('Error checking location permissions:', error);
      // Don't throw - let the flow continue to request push notification permission
    }
  }

  private async ensureDeniedPermissionCounted() {
    try {
      const denialCount = await Preferences.get({ key: 'LOCATION_PERMISSION_DENIAL_COUNT' });
      const currentCount = denialCount.value ? parseInt(denialCount.value) : 0;
      
      // If count is 0, this is the first time we detect it as denied, count it as 1
      // If count is 1, this means user denied once before, and now it's still denied, so count as 2
      // This handles the case where permission was denied before we started counting
      if (currentCount === 0) {
        await Preferences.set({ key: 'LOCATION_PERMISSION_DENIAL_COUNT', value: '1' });
        console.log('Location permission denied count (first detection): 1');
      } else if (currentCount === 1) {
        // User denied once, and permission is still denied, so this counts as the second denial
        await Preferences.set({ key: 'LOCATION_PERMISSION_DENIAL_COUNT', value: '2' });
        console.log('Location permission denied count (second detection): 2');
      }
      // If count is already 2 or more, don't increment further
    } catch (error) {
      console.error('Error ensuring denied permission counted:', error);
    }
  }

  private async incrementLocationPermissionDenialCount() {
    try {
      const denialCount = await Preferences.get({ key: 'LOCATION_PERMISSION_DENIAL_COUNT' });
      let count = denialCount.value ? parseInt(denialCount.value) : 0;
      count++;
      await Preferences.set({ key: 'LOCATION_PERMISSION_DENIAL_COUNT', value: count.toString() });
      console.log('Location permission denied count:', count);
    } catch (error) {
      console.error('Error incrementing location permission denial count:', error);
    }
  }

  async requestPushNotificationPermission() {
    if (!Capacitor.isNativePlatform()) {
      return;
    }

    try {
      // For Android, check OS version first
      if (this.platform.is('android')) {
        const deviceInfo = await Device.getInfo();
        const osVersion = parseInt(deviceInfo.osVersion);
        console.log('Android OS version:', osVersion);
        
        // Android 13+ requires explicit permission request
        if (osVersion <= 12) {
          console.log('Android version <= 12, push notifications may not require explicit permission request');
          // Still try to register for older Android versions
          try {
            await PushNotifications.register();
            console.log('Push notifications registered for Android <= 12');
          } catch (error) {
            console.error('Error registering push notifications for Android <= 12:', error);
          }
          return;
        }
      }

      let permStatus = await PushNotifications.checkPermissions();
      console.log('Push notification permission status (FIRST):', permStatus.receive);

      // If permission is already granted, just register
      if (permStatus.receive === 'granted') {
        await PushNotifications.register();
        console.log('Push notifications registered (already granted)');
        return;
      }

      // If permission is denied, don't request again
      if (permStatus.receive === 'denied') {
        console.log('Push notification permission denied, skipping request');
        return;
      }

      // If permission is prompt (not yet asked), request it immediately
      // This is the FIRST permission to be requested
      if (permStatus.receive === 'prompt' || permStatus.receive === 'prompt-with-rationale') {
        console.log('Requesting push notification permission (FIRST permission)...');
        // Small delay to ensure app UI is ready
        await new Promise(resolve => setTimeout(resolve, 200));
        
        permStatus = await PushNotifications.requestPermissions();
        console.log('Push notification permission request result:', permStatus.receive);

        if (permStatus.receive === 'granted') {
          await PushNotifications.register();
          console.log('Push notifications registered (newly granted)');
        } else if (permStatus.receive === 'prompt-with-rationale') {
          // Android specific: if rationale is needed, try again after a delay
          console.log('Android prompt-with-rationale, will retry after delay...');
          setTimeout(async () => {
            try {
              const retryStatus = await PushNotifications.requestPermissions();
              console.log('Android push notification retry result:', retryStatus.receive);
              if (retryStatus.receive === 'granted') {
                await PushNotifications.register();
                console.log('Push notifications registered after retry');
              }
            } catch (error) {
              console.error('Error retrying push notification permission:', error);
            }
          }, 2000);
        }
      }
    } catch (error) {
      console.error('Error requesting push notification permission:', error);
    }
  }

  private saveTokenToDB(token: string, _caller?: string) {
    if (token != null) {
      localStorage.setItem('TOKEN', token);
      Preferences.set({ key: 'TOKEN', value: token }).then((_val) => {
        console.log('token saved to DB');
      });
    }
  }

  addListeners = async () => {
    if (!Capacitor.isNativePlatform()) {
      console.log('Not native platform, skipping push notification listeners');
      return;
    }

    try {
      await PushNotifications.addListener('registration', token => {
        console.log(token.value)
        if (this.platform.is('android')) {
          this.saveTokenToDB(token.value, 'getTokenAndroid');
        }

        if (!this.platform.is('android')) {
          this.saveTokenToDB(token.value);
        }
      });

      await PushNotifications.addListener('registrationError', err => {
        console.error('Registration error: ', err.error);
      });

      await PushNotifications.addListener('pushNotificationReceived', _notification => {
        // alert('Push notification received: ' + JSON.stringify(notification));
      });

      await PushNotifications.addListener('pushNotificationActionPerformed', notification => {
        this.onMessageReceived(notification)
      });
    } catch (error) {
      console.error('Error setting up push notification listeners:', error);
    }
  }

  registerNotifications = async () => {
    if (!Capacitor.isNativePlatform()) {
      console.log('Not native platform, skipping push notification registration');
      return;
    }

    try {
      let permStatus = await PushNotifications.checkPermissions();

      if (permStatus.receive === 'prompt') {
        permStatus = await PushNotifications.requestPermissions();
      }

      if (permStatus.receive !== 'granted') {
        throw new Error('User denied permissions Post Notification!');
      }

      await PushNotifications.register();
    } catch (error) {
      console.error('Error registering push notifications:', error);
    }
  }

  requestPermissionCamera = async () => {
    if (!Capacitor.isNativePlatform()) {
      console.log('Not native platform, skipping camera permission request');
      return;
    }

    try {
      let permStatus = await Camera.checkPermissions();

      if (permStatus.camera === 'prompt') {
        permStatus = await Camera.requestPermissions();
      }

      if (permStatus.camera !== 'granted') {
        throw new Error('User denied permissions Camera!');
      }
    } catch (error) {
      console.error('Error requesting camera permissions:', error);
    }
  }

  getDeliveredNotifications = async () => {
    if (!Capacitor.isNativePlatform()) {
      console.log('Not native platform, skipping delivered notifications');
      return;
    }

    try {
      const notificationList = await PushNotifications.getDeliveredNotifications();
      console.log('delivered notifications', notificationList);
    } catch (error) {
      console.error('Error getting delivered notifications:', error);
    }
  }

  async checkAndRequestNotificationPermission(): Promise<boolean> {
    if (Capacitor.isNativePlatform()) {
      try {
        const status = await PushNotifications.checkPermissions();
        if (status.receive === 'granted') {
          await PushNotifications.register();
          return true;
        } else {
          const requestStatus = await PushNotifications.requestPermissions();
          if (requestStatus.receive === 'granted') {
            await PushNotifications.register();
            return true;
          }
        }
      } catch (error) {
        console.error(JSON.stringify(error));
      }
      return false;
    }
    return false;
  }

  getGPSRead() {
    void this.locationService.subscribeLocationRefresher();

    Preferences.get({ key: 'LAST_LOCATION' }).then((val) => {
      val = val.value ? JSON.parse(val.value) : null;
      if (val === null) {
        Preferences.set({ key: 'LAST_LOCATION', value: JSON.stringify(environment.locationDefault) }).then((_val) => {
          console.log('lastLocation saved to DB')
        })
      }
    });
  }

  // async getValueTestAB() {
  //   try {
  //     let value = await this.fcm.getValue('avocado_store_v4');
  //     console.log(value);
  //   } catch (error) {
  //     console.error(error);
  //     return false;
  //   }
  // }
  onMessageReceived(message: any) {
    console.log('Push notification received:', JSON.stringify(message));
    if (message.actionId === 'tap') {
      console.log(`Notification was tapped in the ${message.notification.data.tap}`);
      console.log('Notification data:', JSON.stringify(message.notification.data));
      if (message.notification.data.notifType == NotificationsTypesEnum.SUPER_LIKE) {
        this.router.navigateByUrl('/tabs/super-like');
      } else if (message.notification.data.notifType == NotificationsTypesEnum.NEW_MESSAGE) {
        this.verifyIsUserValid(message.notification.data.fromId);
        this.router.navigateByUrl('/tabs/chat-list');
      } else if (message.notification.data.notifType == NotificationsTypesEnum.EXTERNAL_URL) {
        console.log('Opening external URL:', message.notification.data.url);
        this.openLinkExternal(message.notification.data.url)
      } else if (message.notification.data.notifType == NotificationsTypesEnum.NEW_MATCH) {
        this.router.navigateByUrl('/tabs/chat-list');
      } else if (message.notification.data.notifType == NotificationsTypesEnum.DARK_MODE) {
        this.openThemeSettings();
      } else if (message.notification.data.notifType == NotificationsTypesEnum.NEW_LIKES) {
        // this.router.navigateByUrl('/tabs/home');
        // HomePage.likedBySelected = true;
        this.router.navigateByUrl('/tabs/home');
        this.eventService.publish('pushNotification-newLike', true);
      } else if (message.notification.data.notifType == NotificationsTypesEnum.NEW_PHOTO) {
        this.openMatchProfile(message.notification.data.fromId);
      }
    } else {
      if (message.notification.data.notifType != undefined && message.notification.data.notifType != null) {
        if (message.notification.data.notifType == NotificationsTypesEnum.SUPER_LIKE) {
          //AppModule.superLikeSubject.next(null);
        } else if (message.notification.data.notifType == NotificationsTypesEnum.NEW_MESSAGE || message.notification.data.notifType == NotificationsTypesEnum.NEW_MATCH) {
          this.matchService.ensureLoggedInAndCheckForNew();
        }
      }
    }
  }

  public async fetchRemoteConfig() {
    // if (this.isNative) {
    //   await this.firebasePlugin.fetch(async function (result:any) {

    //   }, function () {
    //     // error callback
    //   });
    // }
  }


  openLinkExternal(url: any) {
    console.log('openLinkExternal called with URL:', url);
    if (url === 'fyra://fyra/promotions/club' || url === 'fyra://promotions/club') {
      // Set flag so home page skips opening club again when refreshMyData completes (prevents double-open)
      Preferences.set({ key: 'CLUB_OPENED_FROM_NOTIFICATION_THIS_SESSION', value: 'true' }).then(() => {
        this.openMembership();
      });
    } else if (url === 'fyra://fyra/survey' || url === 'fyra://survey') {
      this.openSurvey();
    } else if (url.startsWith("https://fyradating.com") || url.startsWith("https://www.fyradating.com")) {
      const slug = url.replace(/^https:\/\/(www\.)?fyradating\.com/, '');
      if (slug === '/survey') {
        this.openSurvey();
        return;
      } else if (slug === '/promotions/club') {
        Preferences.set({ key: 'CLUB_OPENED_FROM_NOTIFICATION_THIS_SESSION', value: 'true' }).then(() => {
          this.openMembership();
        });
        return;
      }
    } else {
      // Use InAppBrowser for external URLs from push notifications
      console.log('Opening external URL with InAppBrowser:', url);
      InAppBrowser.open({ url: url }).then(() => {
        console.log('InAppBrowser opened successfully');
      }).catch((error) => {
        console.error('Error opening InAppBrowser:', error);
      });
    }


  }

  @WebBlocker()
  async openMembership(_from?: string) {
    const modal = this.modalCtrl.create({ component: StoreV2Page, componentProps: { me: this.userData, type: "club" }, showBackdrop: true, backdropDismiss: true });
    (await modal).present();
  }

  async openSurvey() {
    const modal = this.modalCtrl.create({ component: SurveyPage });

    (await modal).onDidDismiss().then((val: any) => {

      console.log(val);
      if (val != undefined && val != null && val.data != 'cancelled') {
        // this.userData = val;
        this.surveyEnabled = this.userData.survey5Answers === undefined;
      }
    });

    (await modal).present();
  }

  verifyIsUserValid(fromId: any) {
    this.matchService.souls.forEach((otherSoul: any) => {
      if (otherSoul._id.$oid === fromId) {
        this.openChat(otherSoul)
      }
    })
  }

  openMatchProfile(fromId: any) {
    if (!fromId) {
      return;
    }
    const matchSoul = this.matchService.souls?.find((otherSoul: any) => otherSoul._id.$oid === fromId);
    if (matchSoul) {
      this.modalCtrl.create({
        component: ProfileDisplayPage,
        componentProps: { theSoul: matchSoul }
      }).then((modal) => modal.present());
    } else {
      // Match not loaded locally yet (e.g. cold start): fetch the profile from the server
      this.openProfile(fromId);
    }
  }

  async openChat(soulToChat: any) {
    const latestUserData = await Preferences.get({ key: 'USER_DATA' });
    this.userData = latestUserData.value ? JSON.parse(latestUserData.value) : null;
    if (!this.userData) {
      this.router.navigateByUrl('/login');
      return;
    }

    console.log(this.userData)
    console.log(soulToChat)

    const modal = this.modalCtrl.create({ component: ChatPage, componentProps: { me: this.userData, otherSoul: soulToChat, }, backdropDismiss: true });

    (await modal).onDidDismiss().then((val) => {
      console.log('Data returned from chat modal: ' + JSON.stringify(val.data));
      if (val && val.data === "logout") {
        this.router.navigateByUrl('/login');
        return;
      }

      if (val && val.data === "shouldRefreshList") {
        this.matchService.loadMatches(false);
      }
    });

    (await modal).present();
  }

  private saveToStorage(name: string, value: string) {
    Preferences.set({ key: name, value: value }).then((_val) => {
      console.log(name + ' saved to DB = ' + value);
    })
  }

  private setAnalyticsUserIds() {
    Preferences.get({ key: 'USER_DATA' }).then(async (val) => {
      const storedUserData = val.value ? JSON.parse(val.value) : null;
      const userId = storedUserData?._id?.$oid || null;

      // Firebase Analytics: set identity when we have an id; clear only when
      // there is no stored session (logout). Incomplete USER_DATA without _id
      // must not push a null identity into Crashlytics/PostHog.
      try {
        if (userId) {
          await this.firebaseAnalytics.setUserId(userId);
        } else if (storedUserData == null) {
          await this.firebaseAnalytics.setUserId(null);
        }
      } catch (error) {
        console.error('Firebase Analytics setUserId error:', error);
      }

      if (storedUserData != null && userId) {
        this.userData = storedUserData;
        this.firebaseCrashlytics.setUserId(userId);

        // Identify user in PostHog for session replay and analytics
        // Note: Only sending user ID and non-PII properties for privacy
        try {
          await this.posthog.identify(userId, {
            app: 'fyra',
            platform: Capacitor.getPlatform(),
            has_premium: this.userData.premium || false,
            account_type: this.userData.accountType || 'free'
          });
        } catch (error) {
          console.error('PostHog identify error:', error);
        }
      } else if (storedUserData != null) {
        this.userData = storedUserData;
      }
    })
  }

  async setNavigationBarColor() {
    if (Capacitor.isNativePlatform()) {
      await StatusBar.setBackgroundColor({ color: '#ffffff' }); //[CHANGE-COLOR]
    }
  }

}
